import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { AuthedApi, GuestApi } from "../../api/Api";
import { GetRoutes } from "./Pages";
import { useEffect, useState } from "react";
import useAuthedApi from "../../api/useAuthedApi";
import LoginPage from "./LoginPage";
import { Stack, Box } from "@mui/material";
import PageHeader from "../../components/Header";
import { Action, VoidAction } from "../../util/func";
import useNavigateParams from "../../util/navigate";
import { useNotifyDialogDialog } from "../../components/dialog/NotifyDialog";

export function RouteWrapper({ originalPath }: { originalPath?: string }) {
  const navigate = useNavigateParams();

  const [errors, setErrors] = useState<string[]>([]);
  const [api, updateApi] = useAuthedApi((e) => setErrors([...errors, e]));
  const [notifyDialog, showNotifyDialog] = useNotifyDialogDialog();

  useEffect(() => {
    if (api && originalPath) {
      navigate(originalPath);
    }
  }, [api]);

  useEffect(() => {
    if (errors.length > 0) {
      showNotifyDialog({ title: "エラー", text: errors.join("\n\n"), onClose: () => setErrors([])});
    }
  }, [errors]);

  if (api === undefined) {
    return <>Apiをロード中です。</>;
  }

  return (
    <Stack height="100%">
      <Box flex={1} overflow="auto">
        <Routes>
          <Route path="login/" element={<LoginPageElement updateApi={updateApi} originalPath={originalPath} showError={(e) => setErrors([...errors, e])} />} />
          <Route path="*" element={<RequireAuth api={api} />}>
            {GetRoutes({ api: api!, update: updateApi })}
          </Route>
        </Routes>
      </Box>
      {notifyDialog}
    </Stack>
  );
}

// Apiが認証済(現在のユーザーが設定されている)
function RequireAuth({ api }: { api: AuthedApi | null }) {
  const location = useLocation();
  if (api === null) {
    return <Navigate to="/system-admin/login/" replace state={{ from: location }} />;
  }
  return <Outlet />;
}

function LoginPageElement({ updateApi, originalPath, showError } : { updateApi: VoidAction, originalPath?: string, showError: Action<string> }) {
  const navigate = useNavigateParams();

  return (
    <>
      <PageHeader />
      <LoginPage
        login={async ({ username, password }) => {
          const api = new GuestApi();
          const success = await api.Login(username, password, showError);
          if (success) {
            updateApi();
            navigate(originalPath ?? "/system-admin/top/");
          }
        }}
      />
    </>
  );
}